import styled from 'styled-components';
import { AutoSizer } from 'react-virtualized';
import { getScrollBarStyles } from '../../config/styles';
import { theme } from '../../styles/theme';

export const TableAutoSizer = styled(AutoSizer)`
  .ReactVirtualized__Grid {
    ${getScrollBarStyles(4)};

    &::-webkit-scrollbar-button {
      width: 0 !important;
      background-color: ${theme.colors.secondary400};
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
    &::-webkit-scrollbar-track {
      background-color: ${theme.colors.secondary300};
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.secondary400} !important;
    }

    // remove outline on table when focus.
    outline: none;
  }
`;
